import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { BannerService } from '../../services/banner/BannerService'
import { BannerState } from './types'

const initialState: BannerState = {
  bannerImage: null,
  isBannerActive: true,
  isGetAllBannerDetailLoading: false,
  isGetAllBannerLoading: false,
  isGetBannerDetailByIdLoading: false,
  isCreateBannerLoading: false,
  isDeleteBannerLoading: false,
  isUpdateBannerLoading: false,
  banners: [],
  bannerDetails: [],
  currentMenu: '',
  currentPosition: ''
}

const slice = createSlice({
  name: 'banner',
  initialState,
  reducers: {
    toggleBannerActive: (state) => {
      state.isBannerActive = !state.isBannerActive
    },
    setBannerImage: (state, action: PayloadAction<File | null>) => {
      state.bannerImage = action.payload
    },
    resetBannerState: () => initialState
  },
  extraReducers: (builder) => {
    builder
      .addCase(BannerService.getAllBannerAsyncThunk.pending, (state) => {
        state.isGetAllBannerLoading = true
      })
      .addCase(BannerService.getAllBannerAsyncThunk.rejected, (state) => {
        state.isGetAllBannerLoading = false
      })
      .addCase(BannerService.getAllBannerAsyncThunk.fulfilled, (state, action) => {
        state.isGetAllBannerLoading = false
        state.banners = action.payload.banners
      })
      .addCase(BannerService.getAllBannerDetailsAsyncThunk.pending, (state) => {
        state.isGetAllBannerDetailLoading = true
      })
      .addCase(BannerService.getAllBannerDetailsAsyncThunk.rejected, (state) => {
        state.isGetAllBannerDetailLoading = false
      })
      .addCase(BannerService.getAllBannerDetailsAsyncThunk.fulfilled, (state, action) => {
        state.isGetAllBannerDetailLoading = false
        state.bannerDetails = action.payload.bannerDetails
        state.currentMenu = action.payload.menu
        state.currentPosition = action.payload.position
      })
      .addCase(BannerService.getBannerByIdAsyncThunk.pending, (state) => {
        state.isGetBannerDetailByIdLoading = true
      })
      .addCase(BannerService.getBannerByIdAsyncThunk.rejected, (state) => {
        state.isGetBannerDetailByIdLoading = false
      })
      .addCase(BannerService.getBannerByIdAsyncThunk.fulfilled, (state, action) => {
        state.isGetBannerDetailByIdLoading = false
        state.bannerDetailById = action.payload.banner
        state.isBannerActive = action.payload.banner.isActive
      })
      .addCase(BannerService.createBannerAsyncThunk.pending, (state) => {
        state.isCreateBannerLoading = true
      })
      .addCase(BannerService.createBannerAsyncThunk.rejected, (state) => {
        state.isCreateBannerLoading = false
      })
      .addCase(BannerService.createBannerAsyncThunk.fulfilled, (state) => {
        state.isCreateBannerLoading = false
      })
      .addCase(BannerService.updateBannerAsyncThunk.pending, (state) => {
        state.isUpdateBannerLoading = true
      })
      .addCase(BannerService.updateBannerAsyncThunk.rejected, (state) => {
        state.isUpdateBannerLoading = false
      })
      .addCase(BannerService.updateBannerAsyncThunk.fulfilled, (state) => {
        state.isUpdateBannerLoading = false
      })
      .addCase(BannerService.deleteBannerAsyncThunk.pending, (state) => {
        state.isDeleteBannerLoading = true
      })
      .addCase(BannerService.deleteBannerAsyncThunk.rejected, (state) => {
        state.isDeleteBannerLoading = false
      })
      .addCase(BannerService.deleteBannerAsyncThunk.fulfilled, (state) => {
        state.isDeleteBannerLoading = false
      })
  }
})

export const { resetBannerState, setBannerImage, toggleBannerActive } = slice.actions
export default slice.reducer
